import { Link } from 'react-router-dom';
import { Button, Card, Header } from 'semantic-ui-react';

const AdminPanel = () => {
  return (
    <Card fluid>
      <Card.Header style={{ textAlign: 'center' }}>
        <Header as="h1">Admin Console</Header>
      </Card.Header>
      <Card.Content>
        <Card.Group centered>
          <Card>
            <Link to="/clients">
              <Button size="massive" fluid>
                Manage Clients
              </Button>
            </Link>
          </Card>
          <Card>
            <Link to="/tasks">
              <Button size="massive" fluid>
                Manage Tasks
              </Button>
            </Link>
          </Card>
        </Card.Group>
      </Card.Content>
    </Card>
  );
};

export default AdminPanel;
